<template>
  <material-card
    :title="$t('components.plancreationwizard.members_data_fields')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="folder_shared"
  >
    <v-dialog scrollable v-model="dialog" persistent max-width="500px">
      <material-card :title="requiredFieldsTitle" icon="add" :color="$vuetify.theme.themes.light.success">
        <v-card-text>
          <v-form>
            <v-container fluid grid-list-md>
              <v-row>
                <v-col xs="12">
                  <v-checkbox
                    v-model="requiredField"
                    :label="$t('validation.required')"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="dialog = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="primary" @click="tryAddMemberFields">
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <DualListBox
      :disabled="disabled"
      :source="unselectedFieldsInternal"
      :destination="selectedFieldsInternal"
      label="Label"
      @onChangeList="onChangeList"
    />
    <error-handler :error="error"></error-handler>
  </material-card>
</template>

<script>
import { mapGetters } from "vuex";
import DualListBox from "dual-listbox-vue";
// import "dual-listbox-vue/dist/dual-listbox.css";
import ErrorHandler from "@/components/ErrorHandler";
export default {
  components: {
    DualListBox,
    ErrorHandler,
  },
  props: ["selectedFields", "unselectedFields", "disabled"],
  data() {
    return {
      selectedFieldsInternal: [],
      unselectedFieldsInternal: [],
      error: null,
      isNew: false,
      requiredField: false,
      sourceFields: [],
      destinationFields: [],
      dialog: false,
    };
  },
  computed: {
    requiredFieldsTitle() {
      if (
        this.unselectedFieldsInternal.length - this.sourceFields.length ===
        1
      ) {
        return this.$t(
          "components.plancreationwizard.select_optional_or_required_field"
        );
      } else {
        return this.$t(
          "components.plancreationwizard.select_optional_or_required_field_plural"
        );
      }
    },
  },
  watch: {
    selectedFields: {
      handler(v) {
        this.selectedFieldsInternal = v;
      },
    },
    unselectedFields: {
      handler(v) {
        this.unselectedFieldsInternal = v;
      },
    },
  },
  mounted() {
    this.selectedFieldsInternal = this.selectedFields;
    this.unselectedFieldsInternal = this.unselectedFields;
  },
  methods: {
    onChangeList: function({ source, destination }) {
      if (this.unselectedFieldsInternal.length > source.length) {
        this.sourceFields = source;
        this.destinationFields = destination;
        this.requiredField = false;
        this.dialog = true;
      } else {
        this.unselectedFieldsInternal = source.map((o) => {
          o.Label = o.Label.split("(")[0].trim();
          delete o.IsOptional;
          return o;
        });
        this.selectedFieldsInternal = destination;
        this.$emit("update-selection", this.selectedFieldsInternal);
      }
    },
    tryAddMemberFields() {
      this.unselectedFieldsInternal = this.sourceFields;
      let destinationFields = this.destinationFields.map((o) => {
        const name = this.requiredField
          ? `${o.Label} (required)`
          : `${o.Label} (optional)`;
        o.IsOptional =
          o.Label.indexOf("(") === -1 ? !this.requiredField : o.IsOptional;
        o.Label = o.Label.indexOf("(") === -1 ? name : o.Label;
        return o;
      });
      this.selectedFieldsInternal = destinationFields;
      this.dialog = false;
      this.$emit("update-selection", this.selectedFieldsInternal);
    },
  },
};
</script>

<style></style>
